module.exports = __webpack_public_path__ + "static/media/librery2.4d79b7fb.jpg";